import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PackageSearch } from "lucide-react";

import api, { formatApiError } from "@/lib/api";

export default function IndentsPage() {
  const [indents, setIndents] = useState(null);

  const load = async () => {
    setIndents(null);
    try {
      const { data } = await api.get("/indents");
      setIndents(data || []);
    } catch (err) {
      setIndents([]);
      toast.error(formatApiError(err?.response?.data?.detail) || err.message);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="indents-page">
      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-slate-500">Inventory</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-extrabold text-slate-900" style={{ fontFamily: "Manrope" }}>Indents</h1>
        <p className="text-sm text-slate-500 mt-1">
          Material requisitions auto-raised whenever stock moves from the Semi Finished Store to Assembly — either an SFG
          job advancing stage, or SFG-BOM components consumed to build one.
        </p>
      </div>

      <section className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b border-slate-100 text-sm font-semibold text-slate-700 flex items-center justify-between">
          <span>Indents</span><span className="text-xs text-slate-500 mono">{indents?.length ?? "—"}</span>
        </div>
        {indents === null && <div className="py-10 text-center text-sm text-slate-500">Loading…</div>}
        {indents && indents.length === 0 && (
          <div className="py-14 text-center text-slate-400">
            <PackageSearch className="w-10 h-10 mx-auto mb-2" />
            <p className="text-sm">No indents raised yet.</p>
          </div>
        )}
        {indents && indents.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[10px] uppercase tracking-[0.14em] text-slate-500 bg-slate-50">
                  <th className="py-2.5 px-4">Indent No</th>
                  <th className="py-2.5 px-4">Job</th>
                  <th className="py-2.5 px-4">Route</th>
                  <th className="py-2.5 px-4">Lines</th>
                  <th className="py-2.5 px-4">Reason</th>
                  <th className="py-2.5 px-4">Raised</th>
                </tr>
              </thead>
              <tbody>
                {indents.map((ind) => (
                  <tr key={ind.id} className="border-t border-slate-100" data-testid={`indent-row-${ind.code}`}>
                    <td className="py-2.5 px-4 mono font-semibold text-blue-700">{ind.code}</td>
                    <td className="py-2.5 px-4 mono text-xs text-slate-500">{ind.job_code || "—"}</td>
                    <td className="py-2.5 px-4 text-xs text-slate-700">
                      Semi Finished Store <span className="text-slate-400">→</span> Assembly Store
                    </td>
                    <td className="py-2.5 px-4">
                      {(ind.lines || []).map((l, i) => (
                        <div key={i} className="text-xs text-slate-700">
                          <span className="mono text-slate-500">{l.item_code}</span> {l.item_name} — <span className="mono">{l.qty} {l.uom}</span>
                        </div>
                      ))}
                    </td>
                    <td className="py-2.5 px-4 text-xs text-slate-600 max-w-sm truncate">{ind.reason || "—"}</td>
                    <td className="py-2.5 px-4 text-xs text-slate-500">
                      {ind.created_at ? new Date(ind.created_at).toLocaleString() : "—"}<br />
                      <span className="text-slate-400">by {ind.raised_by || "—"}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
